import styled from 'styled-components';

import bnb from 'assets/Common/ContractLinks/bnb.svg';
import copy from 'assets/Common/ContractLinks/copy.svg';
import check from 'assets/Common/ContractLinks/check.svg';

import vars from 'variables';

const Root = styled.div`
  display: inline;

  .address {
    display: inline-block;
    font-weight: bold;
    letter-spacing: 0.5px;
    background: ${vars.colors.marineBlue} no-repeat;
    background-image: url(${bnb}),
                      url(${copy});
  }

  .address.copied {
    background-image: url(${bnb}),
                      url(${check});
  }

  ${vars.desktop.mediaQuery} {
    .address {
      padding-left: 56px;
      padding-right: 46px;
      line-height: 59px;
      background-position: center left 20px,
                           center right 16px;
      border-radius: 10px;
    }
  }

  ${vars.mobile.mediaQuery} {
    .address {
      padding-left: 43px;
      padding-right: 39px;
      line-height: 46px;
      background-position: center left 20px,
                           center right 18px;
      background-size: 16px,
                       13px;
      border-radius: 6px;
    }
  }
`;

export { Root };
